import React from "react";
import { IconArrowUpRight } from "@tabler/icons-react";
import Button from "../../../../components/ui/Button";

interface Props {
  zoneName: string;
}

const ZoneActions: React.FC<Props> = ({ zoneName }) => (
  <div className="mt-auto flex flex-col gap-3">
    <Button variant="default" size="lg" className="w-full !rounded-xl !gap-2">
      <span className="leading-none text-sm md:text-base flex justify-stretch" style={{ display: "ruby" }}>
        <IconArrowUpRight size={18} className="mr-2" />
        <span>Ver propiedades en {zoneName}</span>
      </span>
    </Button>
    <Button variant="primary" size="lg" className="w-full !rounded-xl !gap-2">
      <span className="leading-none text-sm md:text-base flex justify-stretch" style={{ display: "ruby" }}>
        <IconArrowUpRight size={18} className="mr-2" />
        <span>Recibir asesoría de esta zona</span>
      </span>
    </Button>
  </div >
);

export default ZoneActions;
